"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shortDateFormat = exports.formatTime = exports.formatShortDate = exports.formatIsoDate = exports.formatFullDate = exports.formatDayAndMonthDate = exports.formatCardDate = exports.formatAPIUtcDate = void 0;
var _dateFnsTz = require("date-fns-tz");
var getTimezone = function getTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
var formatShortDate = function formatShortDate(date) {
  return (0, _dateFnsTz.formatInTimeZone)(date, getTimezone(), 'dd/MM/yy');
};
exports.formatShortDate = formatShortDate;
var formatFullDate = function formatFullDate(date) {
  return (0, _dateFnsTz.formatInTimeZone)(date, getTimezone(), 'dd MMM yyyy');
};
exports.formatFullDate = formatFullDate;
var formatDayAndMonthDate = function formatDayAndMonthDate(date) {
  return (0, _dateFnsTz.formatInTimeZone)(date, getTimezone(), 'd MMM');
};
exports.formatDayAndMonthDate = formatDayAndMonthDate;
var formatIsoDate = function formatIsoDate(date) {
  return (0, _dateFnsTz.formatInTimeZone)(date, getTimezone(), 'yyyy-MM-dd');
};
exports.formatIsoDate = formatIsoDate;
var formatTime = function formatTime(date) {
  return (0, _dateFnsTz.formatInTimeZone)(date, getTimezone(), 'h:mm b');
};
exports.formatTime = formatTime;
var formatCardDate = function formatCardDate(date) {
  return (0, _dateFnsTz.formatInTimeZone)(date, getTimezone(), 'MM/yy');
};
exports.formatCardDate = formatCardDate;
var formatAPIUtcDate = function formatAPIUtcDate(date) {
  return (0, _dateFnsTz.formatInTimeZone)(date, 'UTC', 'yyyy-MM-dd');
};
exports.formatAPIUtcDate = formatAPIUtcDate;
var shortDateFormat = 'dd/MM/yy';
exports.shortDateFormat = shortDateFormat;